/**
 * External Dependencies
 */
import AOS from 'aos'
import Swup from 'swup'
import SwupPreloadPlugin from '@swup/preload-plugin'
import SwupFadeTheme from '@swup/fade-theme'
import SwupScrollPlugin from '@swup/scroll-plugin'
import SwupBodyClassPlugin from '@swup/body-class-plugin'
import { Swiper, Autoplay, Navigation, EffectFade, A11y } from 'swiper'
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'

Swiper.use([Autoplay, Navigation, EffectFade, A11y])

const load = () => {
  // Navigation
  const menuToggle = document.getElementById('menu-toggle')

  menuToggle.addEventListener('click', () => {
    const menuWidth = document.getElementById('site-navigation').offsetWidth
    document.documentElement.style.setProperty('--menu-width', `-${menuWidth}px`)

    if (!document.body.classList.contains('menu-open')) {
      document.body.classList.add('menu-open')
    } else {
      if (window.location.search) {
        swup.loadPage({url: '/'})
      } else if (window.location.pathname == '/') {
        document.body.classList.remove('menu-open')
      } else {
        swup.loadPage({url: '/'})
      }
    }
  })

  // Nav open on hover
  if (window.innerWidth >= 640) {
    setTimeout(() => {
      menuToggle.addEventListener('mouseenter', () => {
        const menuWidth = document.getElementById('site-navigation').offsetWidth
        document.documentElement.style.setProperty('--menu-width', `-${menuWidth}px`)

        if (!document.body.classList.contains('menu-open')) {
          document.body.classList.add('menu-open')
        }
      })
    }, 100)
  }

  const navClose = document.getElementById('nav-close')
  navClose.addEventListener('click', () => {
    document.body.classList.remove('menu-open')
  })

  const headerUnderlay = document.getElementById('header-underlay')
  headerUnderlay.addEventListener('click', () => {
    document.body.classList.remove('menu-open')
  })

  // Mobile Nav hide on scroll
  const header = document.querySelector('#site-header')
  let lastScrollPosition = 0
  document.addEventListener('scroll', () => {
    if (window.scrollY > lastScrollPosition && window.scrollY >= 100) {
      header.classList.add('mobile-hide')
      document.body.classList.remove('menu-open')
    } else {
      header.classList.remove('mobile-hide')
      document.body.classList.remove('menu-open')
    }

    lastScrollPosition = window.scrollY
  })

  // Slideshows
  const projectSliders = document.querySelectorAll('.project-slider')
  if (projectSliders) {
    projectSliders.forEach((slider) => {
      const slideCount = slider.querySelectorAll('.swiper-slide').length
      const navPrev = `#${slider.id}-prev`
      const navNext = `#${slider.id}-next`
      const projectSlider = new Swiper(slider, {
        speed: 500,
        slidesPerView: 'auto',
        spaceBetween: 15,
        grabCursor: true,
        a11y: true,
        initialSlide: slideCount - 1,
        navigation: {
          prevEl: navPrev,
          nextEl: navNext,
        },
      })
    })
  }

  const dynamicSliders = document.querySelectorAll('.dynamic-slider')
  if (dynamicSliders) {
    dynamicSliders.forEach((slider) => {
      const counter = slider.querySelector('.counter')
      new Swiper(slider, {
        speed: 500,
        grabCursor: true,
        a11y: true,
        on: {
          slideChange: (slider) => {
            counter.innerHTML = slider.activeIndex + 1
          }
        }
      })
    })
  }

  const imageSliders = document.querySelectorAll('.image-slider')
  if (imageSliders) {
    imageSliders.forEach((slider) => {
      const counter = slider.querySelector('.counter')
      new Swiper(slider, {
        speed: 500,
        grabCursor: true,
        a11y: true,
        on: {
          slideChange: (slider) => {
            counter.innerHTML = slider.activeIndex + 1
          }
        }
      })
    })
  }

  // Modals
  const modalBtns = document.querySelectorAll('.modal-btn')
  const modalCloseBtns = document.querySelectorAll('.modal-close')
  const modalOverlays = document.querySelectorAll('.modal-overlay')
  let openModal = false

  const toggleModal = (modal) => {
    modal.classList.toggle('open')
    document.body.classList.toggle('modal-open')

    if (openModal != modal) {
      openModal = modal
    } else {
      openModal = false
    }
  }

  modalBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (openModal) {
        toggleModal(openModal)
      }

      let modal = document.querySelector('#' + btn.dataset.modal)
      toggleModal(modal)
    })
  })

  modalCloseBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const modal = e.target.closest('.modal')
      toggleModal(modal)
    })
  })

  modalOverlays.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const modal = e.target.closest('.modal')
      toggleModal(modal)
    })
  })

  // Masonry & Images Loaded
  const masonry = document.querySelector('.masonry')
  if (masonry) {
    new imagesLoaded(masonry, () => {
      new Masonry(masonry, {
        itemSelector: '.masonry-item',
        columnWidth: '.masonry-sizer',
        percentPosition: true,
      })
    })
  }

  // Accordion
  const accordion = document.querySelector('.accordion')
  if (accordion) {
    const items = accordion.querySelectorAll('.accordion-item')

    const closeItems = () => {
      items.forEach((item) => {
        item.classList.remove('open')
      })
    }

    items.forEach((item) => {
      item.addEventListener('click', () => {
        if (item.classList.contains('open')) {
          closeItems()
        } else {
          closeItems()
          item.classList.add('open')
        }
      })
    })
  }

  // Animate On Scroll
  AOS.init({
    once: true,
    duration: 700,
  })
}

//
// Swup
//
const swupOptions = {
  containers: ['#app'],
  animateHistoryBrowsing: true,
  plugins: [
    new SwupPreloadPlugin(),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: false,
    }),
    new SwupBodyClassPlugin(),
    new SwupFadeTheme({
      mainElement: ['#app'],
    }),
  ],
}

const swup = new Swup(swupOptions)
swup.on('animationOutDone', () => {
  if (document.body.classList.contains('menu-open')) {
    document.body.classList.remove('menu-open')
  }
})

swup.on('contentReplaced', () => {
  load()
})

document.addEventListener('DOMContentLoaded', () => {
  load()
})
